class XMenu extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.state = "closed"),
            (this.parent_links = this.querySelectorAll(".x-menu--level-1--link > a")),
            (this.sub_menu_links = this.querySelectorAll('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a')),
            (this.overlap_parent = parseInt(this.getAttribute("data-x-menu--overlap-parent"))),
            (this.header_root = document.querySelector(".header--root")),
            (this.sub_menu_items = []),
            (this.parents_with_sub_menu = []),
            this.sub_menu_links.forEach((e) => {
                var t = e.parentNode;
                this.parents_with_sub_menu.push(t), e.parentNode.querySelectorAll("ul a").forEach((e) => this.sub_menu_items.push(e));
            }),
            this.load();
    }
    disconnectedCallback() {
        this.parent_links.off("focus.XMenu"),
            this.sub_menu_links.off("touchstart.XMenu focus.XMenu"),
            this.parents_with_sub_menu.off("mouseleave.XMenu"),
            this.parents_with_sub_menu.forEach((e) => {
                e.querySelectorAll(":scope > a").off("mouseenter.XMenu");
            });
    }
    load() {
        this.arrangeMegaNav(), this.listeners(), this.checkOverlap(), this.resizeObserver(), this.transitionListeners();
    }
    listeners() {
        this.parents_with_sub_menu.forEach((e) => {
            e.querySelectorAll(":scope > a").on("mouseenter.XMenu", (e) => this.slideDown(e.target));
        }),
            this.parents_with_sub_menu.on("mouseleave.XMenu", () => this.slideUp()),
            this.parent_links.on("focus.XMenu", () => this.slideUp),
            this.sub_menu_links.on("focus.XMenu", (e) => this.slideDown(e.target)),
            this.sub_menu_links.on("touchstart.XMenu", (e) => {
                e.preventDefault(), "true" === e.target.parentNode.getAttribute("data-x-menu--open") ? this.slideUp(!1) : this.slideDown(e.target);
            });
    }
    checkOverlap() {
        if (theme.utils.isTouchDevice && "large" !== theme.mqs.current_window) return this.setAttribute("data-x-menu--overlap", !0), this.header_root.setAttribute("data-x-menu--overlap", !0), window.trigger("theme:XMenu:loaded"), !1;
        this.setAttribute("data-x-menu--overlap", !1), this.header_root.setAttribute("data-x-menu--overlap", !1);
        let e = this;
        1 === this.overlap_parent ? (e = e.parentNode) : 2 === this.overlap_parent && (e = e.parentNode.parentNode);
        var t,
            s,
            r,
            n,
            i = e.parentNode,
            a = e.index();
        let l = !1,
            o = (1 < a && (l = i.children[a - 1]), !1);
        a + 1 < i.children.length && (o = i.children[a + 1]),
            l && ((s = (t = l.querySelector(":scope > :last-child")).offset().left + t.offsetWidth), e.offset().left - 1 <= s) && (this.setAttribute("data-x-menu--overlap", !0), this.header_root.setAttribute("data-x-menu--overlap", !0)),
            o && ((n = (r = e.querySelector(":scope > :last-child")).offset().left + r.offsetWidth), o.offset().left - 1 <= n) && (this.setAttribute("data-x-menu--overlap", !0), this.header_root.setAttribute("data-x-menu--overlap", !0)),
            window.trigger("theme:XMenu:loaded");
    }
    resizeObserver() {
        new ResizeObserver(() => this.checkOverlap()).observe(this.header_root);
    }
    arrangeMegaNav() {
        var e = this.querySelectorAll(".x-menu--single-parents");
        0 === this.parents_with_sub_menu.length ||
            0 < e.length ||
            this.querySelectorAll('[data-x-menu--depth="3"] .x-menu--level-2--container').forEach((e) => {
                var t = e.querySelectorAll('[data-x-menu--single-parent="true"]');
                if (t.length) {
                    const r = new DocumentFragment();
                    t.forEach((e) => r.appendChild(e));
                    var s = theme.utils.parseHtml('<div class="x-menu--single-parents"><ul></ul></div>');
                    s.querySelector("ul").appendChild(r), e.prepend(s);
                }
            });
    }
    slideDown(e, t = !1) {
        clearTimeout(this.timer);
        var s,
            r = e.parentNode;
        if ("true" === r.getAttribute("data-x-menu--open") || "closing" === this.state) return !1;
        this.slideUp(!1),
            t && "complete" !== t
                ? (this.timer = setTimeout(() => this.slideDown(e, "complete"), t))
                : ((r.querySelector(".icon--chevron-up").style.display = "inline"),
                  (r.querySelector(".icon--chevron-down").style.display = "none"),
                  r.setAttribute("data-x-menu--open", !0),
                  (s = r.querySelector(".x-menu--level-2--container")) && (s.setState("forwards"), (s.style.height = "auto")),
                  e.setAttribute("aria-expanded", !0),
                  (this.state = "open"));
    }
    slideUp(e = 300) {
        let t = !1,
            s = !1,
            r;
        for (let i = 0; i < this.parents_with_sub_menu.length; i++)
            if ("true" === (r = this.parents_with_sub_menu[i]).getAttribute("data-x-menu--open")) {
                (s = r), (t = s.querySelector(":scope > a"));
                break;
            }
        var n;
        s &&
            (e
                ? (this.timer = setTimeout(() => this.slideUp(!1), e))
                : ((s.querySelector(".icon--chevron-up").style.display = "none"),
                  (s.querySelector(".icon--chevron-down").style.display = "inline"),
                  s.setAttribute("data-x-menu--open", !1),
                  (n = s.querySelector(".x-menu--level-2--container")) && n.setState("backwards"),
                  t && t.setAttribute("aria-expanded", !1),
                  (this.state = "closing")));
    }
    transitionListeners() {
        this.sub_menu_links.forEach((e) => {
            var t = e.parentNode;
            t &&
                t.querySelectorAll(".x-menu--level-2--container").on("transition:at_start", (e) => {
                    (e.target.style.height = "0"), (this.state = "closed");
                });
        });
    }
}
customElements.define("x-menu-root", XMenu);
